import request from '@/utils/request';

// 1. 获取我的订单数据
export function fetchMyOrderList(params = {}) {
  return request({
    url: '/order-server/customer/orders',
    method: 'get',
    params
  });
}
// 2. 获取我的订单详情数据
export function fetchMyOrderInfo(params = {}) {
  return request({
    url: '/order-server/customer/orders/' + params.orderID,
    method: 'get'
  });
}
// 3. 关闭我的订单数据
export function closeMyOrder(data) {
  return request({
    url: `/order-server/customer/orders/${data.orderID}/close`,
    method: 'POST',
    data
  });
}

// 4. 获取我的订单详情数据状态
export function fetchMyOrderInfoState(data) {
  return request({
    url: `/order-server/customer/orders/${data.orderID}/status`,
    method: 'get'
  });
}

export function fetchIntegralBenefits(params = {}) {
  return request({
    url: `/order-server/markets/${params.marketID}/payments`,
    method: 'get',
    params
  });
}
export function fetchPaymentBusiness(params = {}) {
  return request({
    url: `/order-server/markets/${params.marketID}/payerEnterprises`,
    method: 'get'
  });
}

export function fetchPayments(params) {
  return request({
    url: `/order-server/customers/payments`,
    method: 'get',
    params: params
  });
}

export function getOverviewAboutEnterpriseOrder(params) {
  return request({
    url: `/order-server/customer/overview`,
    method: 'get',
    params: params
  });
}



// WEBPACK FOOTER //
// ./src/api/myOrder.js